import React from "react";
import TabbedPage from "../shared/TabbedPage";
import translate from "../../../../i18n/translate";
import {
  MadaCommission,
  PaltelCommission,
  JawwalInvoiceCommission,
  NedcoCommission,
} from "components/pages/settings/BillCommission";
import ReflectCommission from "components/pages/settings/ReflectCommission";
import GetSettings from "components/pages/settings/IsrealCompanies/IsraelSettings";

// Bill payments: the commission on each bill, then the remaining settings
// rows of the bill services that used to have a page each.
const CommissionsPage = ({ defaultTab }) => (
  <TabbedPage
    id="commissions"
    title={translate("Commissions")}
    intro={translate("commissionsHint")}
    defaultTab={defaultTab}
    tabs={[
      { key: "mada", label: "Mada", render: () => <MadaCommission /> },
      { key: "paltel", label: "Paltel", render: () => <PaltelCommission /> },
      { key: "jawwal_invoice", label: translate("JawwalInvoice"), render: () => <JawwalInvoiceCommission /> },
      { key: "nedco", label: "Nedco", render: () => <NedcoCommission /> },
      { key: "reflect", label: "Reflect", render: () => <ReflectCommission /> },
      { key: "paltel_settings", label: "Paltel " + "⚙", render: () => <GetSettings carrier="paltel" /> },
      { key: "jawwal_invoice_settings", label: "Jawwal invoice ⚙", render: () => <GetSettings carrier="jawwal_invoice" /> },
      { key: "mada_settings", label: "Mada ⚙", render: () => <GetSettings carrier="mada" /> },
      { key: "coolnet_settings", label: "Coolnet ⚙", render: () => <GetSettings carrier="coolnet" /> },
    ]}
  />
);

export default CommissionsPage;
